module.exports = __webpack_public_path__ + "RMR HSA Guía de Inscripcion.pdf";